import { render, staticRenderFns } from "./mandateMoved.vue?vue&type=template&id=294fe974&"
import script from "./mandateMoved.vue?vue&type=script&lang=js&"
export * from "./mandateMoved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports